import { render, staticRenderFns } from "./PostValidateAndSign.vue?vue&type=template&id=82065630&scoped=true&"
import script from "./PostValidateAndSign.vue?vue&type=script&lang=js&"
export * from "./PostValidateAndSign.vue?vue&type=script&lang=js&"
import style0 from "./PostValidateAndSign.vue?vue&type=style&index=0&id=82065630&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82065630",
  null
  
)

export default component.exports